<template>
  <section id="three">
    <h2>research</h2>
    <header>
      <h3>{{headline}}</h3>
      <p>{{contributors}}</p>
    </header>
    <img class="image fit" src="images/darwin.jpg" alt />
    <p>
      <span v-html="text"></span>
    </p>
  </section>
</template>

<script>
export default {
  data: function() {
    return {
      image_source: "images/darwin.jpg",
      headline: "Design it like Darwin 2.0 @ BPM Conference 2017 in Barcelona",
      contributors:
        "Jonas Manderscheid, Maximilian Röglinger, Tobias Ruby, Johannes Seyfried",
      text:
        'Process redesign is an important and valuable phase of the business process management (BPM) lifecycle. However, human creativity and objectiveness re-garding continuous redesign initiatives are limited and biased. To overcome these limitations, we propose computational support based on evolutionary al-gorithms. Our software tool extends a formerly published proof of concept. Novelties have been introduced by including a new data structure, new muta-tion and crossover operators as well as an extended evaluation of unambiguous process designs explicitly considering time objectives. Finally, the tool pro-vides new computation process (re-) design support to the BPM community. <a href="http://bpm2017.cs.upc.edu" target="_blank">see more.</a>'
    };
  }
};
</script>